<script lang="ts" setup>
defineProps<{ title: string }>();

const step = ref<HTMLElement | null>(null);

provide('scrollBack', () => {
  if (step.value) {
    step.value.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });
  }
});
</script>

<template>
  <div ref="step" class="scroll-mt-10">
    <h2 class="text-lg text-gray-700 font-semibold border-b inline-flex mb-3">
      {{ title }}
    </h2>
    <slot></slot>
  </div>
</template>
